import { vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "message-container" }
const _hoisted_2 = { id: "notification" }
const _hoisted_3 = { class: "notification-buttons-container" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  id: "chat"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "from" }
const _hoisted_10 = { class: "message-text" }
const _hoisted_11 = {
  key: 1,
  id: "chat-only-incoming"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "from" }
const _hoisted_14 = { class: "message-text" }
const _hoisted_15 = {
  key: 2,
  id: "new-message",
  class: "row"
}
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: _normalizeClass(["notification-button", { 'input-group': !_ctx.searchHidden }]),
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (!_ctx.searchHidden)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                class: "search-messages text-area form-control",
                type: "text",
                placeholder: _ctx.$t('MESSAGES.SEARCH_PLACEHOLDER'),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchString) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
              }, null, 40, _hoisted_4)), [
                [_vModelText, _ctx.searchString]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn primary",
            disabled: _ctx.searchDisabled,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showSearchBox && _ctx.showSearchBox(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'search'] })
          ], 8, _hoisted_5)
        ], 34),
        _createElementVNode("button", {
          type: "button",
          class: "btn primary notification-button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
          disabled: _ctx.refreshDisabled
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'sync'] })
        ], 8, _hoisted_6)
      ])
    ]),
    (_ctx.user.canSendMessages == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message.id,
              class: _normalizeClass(["message", {
          outgoing: message.senderUsersId == _ctx.user.usersId,
          incoming: message.senderUsersId != _ctx.user.usersId,
          unread:
            message.senderUsersId == _ctx.user.therapist.usersId && !message.readAt
        }]),
              ref_for: true,
              ref: "incomingMessage",
              title: _ctx.formatDate(message.createdAt)
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(message.senderUsersId == _ctx.user.usersId
                ? _ctx.user.username
                : message.senderUsersId == _ctx.user.therapist.usersId
                ? _ctx.user.therapist.name
                : "Moodbuster"), 1),
                _createElementVNode("small", null, "   " + _toDisplayString(_ctx.formatDate(message.createdAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(message.body), 1)
            ], 10, _hoisted_8))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message.id,
              class: _normalizeClass(["message", {
          incoming: message.senderUsersId != _ctx.user.usersId,
          unread:
            message.senderUsersId == _ctx.user.therapist.usersId && !message.readAt
        }]),
              ref_for: true,
              ref: "incomingMessage",
              title: _ctx.formatDate(message.createdAt)
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(message.senderUsersId == _ctx.user.therapist.usersId
                ? _ctx.user.therapist.name
                : "Moodbuster"), 1),
                _createElementVNode("small", null, "   " + _toDisplayString(_ctx.formatDate(message.createdAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(message.body), 1)
            ], 10, _hoisted_12))
          }), 128))
        ])),
    (_ctx.user.canSendMessages == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.sendMessage()), ["prevent"])),
            class: "input-group align-self-center"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event)),
              class: "text-area form-control",
              type: "text",
              placeholder: _ctx.$t('MESSAGES.NEW_MESSAGE_PLACEHOLDER'),
              onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.markMessagesAsRead && _ctx.markMessagesAsRead(...args))),
              required: ""
            }, null, 40, _hoisted_16), [
              [_vModelText, _ctx.message]
            ]),
            _createElementVNode("button", {
              class: "send btn primary",
              type: "submit",
              disabled: _ctx.sendMessageDisabled
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['far', 'paper-plane'] })
            ], 8, _hoisted_17)
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}